import axios from 'axios';
import { useEffect, useState } from 'react';
import { baseUrl } from '../baseUrl';
import { toast } from 'react-toastify';
import './Gallery.css';
import { MagnifyingGlass } from 'react-loader-spinner';

const Gallery = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null); // For modal

    const getImages = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${baseUrl}/gallery/admin?limit=50&show=true`);
            setImages(res.data.gallery);
        } catch (err) {
            toast.error('Something went wrong');
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getImages();
    }, []);

    const openModal = (index) => {
        setCurrentIndex(index);
    };

    const closeModal = () => {
        setCurrentIndex(null);
    };

    const goPrev = () => {
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };

    const goNext = () => {
        if (currentIndex < images.length - 1) setCurrentIndex(currentIndex + 1);
    };

    return (
        <div className='container mb-2'>
            <h3 className='mt-2 text-center'>Gallery</h3>
            {loading &&
                <MagnifyingGlass
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="magnifying-glass-loading"
                    wrapperStyle={{}}
                    wrapperClass="magnifying-glass-wrapper"
                    glassColor="#c0efff"
                    color="#8000df"
                />}
            {!loading && images.length < 1 && <h4>Coming Soon...</h4>}
            {!loading && images.length > 0 && (
                <div className="gallery-grid">
                    {images.map((img, idx) => (
                        <img
                            key={idx}
                            src={`${baseUrl}${img.image}`}
                            alt=""
                            className="gallery-thumbnail"
                            onClick={() => openModal(idx)}
                        />
                    ))}
                </div>
            )}
            {currentIndex !== null && (
                <div className="gallery-modal">
                    <span className="gallery-close" onClick={closeModal}>&times;</span>
                    <button className="gallery-prev" onClick={goPrev} disabled={currentIndex === 0}>&#10094;</button>
                    <img
                        src={`${baseUrl}${images[currentIndex].image}`}
                        alt=""
                        className="gallery-modal-content"
                    />
                    <button className="gallery-next" onClick={goNext} disabled={currentIndex === images.length - 1}>&#10095;</button>
                </div>
            )}

        </div>
    );
};

export default Gallery;
